import { useField } from 'formik';
import React from 'react';

import DateInput from '@components/DateInput/DateInput';

import { normalizeReleaseDate } from './release-date';

interface ReleaseDateFieldProps {
  name?: string;
  label: string;
  required?: boolean;
  maxDate?: Date;
}

/**
 * Formik-safe release date field. Uses `DateInput` directly so we can normalize
 * the UTC-midnight value `DateInput` emits into a local-calendar `Date` without
 * overriding `FormikDateField`'s `onChange` (which would replace Formik wiring
 * because `{...props}` is spread after the internal handler).
 */
function ReleaseDateField({
  name = 'release_date',
  label,
  required = false,
  maxDate,
}: ReleaseDateFieldProps) {
  const [field, meta, helpers] = useField<Date | null>(name);

  return (
    <DateInput
      error={meta.touched ? meta.error : ''}
      label={label}
      maxDate={maxDate}
      name={field.name}
      required={required}
      value={field.value}
      onBlur={field.onBlur}
      onChange={(value) => {
        void helpers.setTouched(true);
        void helpers.setValue(normalizeReleaseDate(value));
      }}
    />
  );
}

export default ReleaseDateField;
